import { Authentication } from './Authentication';
export class ApiKeyAuth extends Authentication {
    constructor(location, paramName) {
        super();
        this.location = location;
        this.paramName = paramName;
        this.apiKey = '';
    }
    async applyToRequest(requestOptions) {
        if (this.location === 'query') {
            requestOptions.params = requestOptions.params || {};
            requestOptions.params[this.paramName] = this.apiKey;
        }
        else if (this.location === 'header') {
            requestOptions.headers = requestOptions.headers || {};
            requestOptions.headers[this.paramName] = this.apiKey;
        }
    }
}
//# sourceMappingURL=ApiKeyAuth.js.map